import { Model } from "@interfaces/model.interface";

export interface MachineAvailability extends Model {
	availabilityDate: Date;
	dayShiftEndTime?: number;
	dayShiftStartTime?: number;
	machineId: number;
	nightShiftEndTime?: number;
	nightShiftStartTime?: number;
}

export class MachineAvailability implements MachineAvailability {
	constructor(data?: Partial<MachineAvailability>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}